import { defineComponent as l, createBlock as o, openBlock as r, unref as n, withCtx as t, createVNode as a, createCommentVNode as i } from "vue";
import f from "../../../../components/LinkList/LinkList.vue.js";
import m from "../../../../features/external-docs/ExternalDocs.vue.js";
import u from "../../../../features/info-object/Contact.vue.js";
import s from "../../../../features/info-object/License.vue.js";
import c from "../../../../features/info-object/TermsOfService.vue.js";
const L = /* @__PURE__ */ l({
  __name: "InfoLinks",
  props: {
    info: {},
    externalDocs: {}
  },
  setup(p) {
    return (e, v) => (r(), o(n(f), null, {
      default: t(() => [
        a(n(m), { value: e.externalDocs }, null, 8, ["value"]),
        e.info.contact ? (r(), o(n(u), {
          key: 0,
          value: e.info.contact
        }, null, 8, ["value"])) : i("", !0),
        e.info.license ? (r(), o(n(s), {
          key: 1,
          value: e.info.license
        }, null, 8, ["value"])) : i("", !0),
        e.info.termsOfService ? (r(), o(n(c), {
          key: 2,
          value: e.info.termsOfService
        }, null, 8, ["value"])) : i("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  L as default
};
